module.exports = __webpack_public_path__ + "asset/font-dollarbird-aef845e90f42779d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/style/icon/fonts/dollarbird.svg
// module id = DXyz
// module chunks = 3